import { useMemo } from 'react';
import { getQueryParamByName } from '../utilities/queryParameters';
import { mobileWebViewQueryParam } from '../../components/privacyFeedback/constants';

export const useIsWebView = (): boolean => {
    return useMemo(() => {
        const hasSQueryParam = getQueryParamByName(mobileWebViewQueryParam);
        return !!hasSQueryParam;
    }, []);
};